module.exports = __webpack_public_path__ + "img/none.9e1c0268.webp";